export default __webpack_public_path__ + "static/media/+-inside-calendar.8e67ea43.svg";